import { BaseDataService } from './basedata.service';
import { HttpService } from './http.service';
import { API_URL } from '../../constants/url.constants';
import { BaseDataModel } from '../../models/utilitymodels/base.model';
import { Injectable } from '@angular/core';
import { environment } from 'common/environment/environment.dev';

@Injectable({
    providedIn: 'root',
})
export abstract class FormDataService<T extends BaseDataModel> extends BaseDataService<T> {
    constructor(public API_URL: API_URL, protected httpService: HttpService) {
        super(API_URL, httpService);
    }

    postData(model: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            Promise.resolve()
                .then(() => {
                    console.log(model);

                    return this.beforePostData(model);
                })
                .then((returnModel) => {

                    return this.postDatatoAPI(returnModel);
                })
                .then((result) => {
                    const prepareAPIErrorMessage = this.prepareAPIErrorMessage(result);
                    if (prepareAPIErrorMessage === null) {
                        return this.afterPostData(result);
                    } else {

                        return this.API_URL.startsWith(environment.logicAPI) ? reject(prepareAPIErrorMessage) : result;
                    }
                })
                .then((finalresult) => {

                    resolve(finalresult);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    getData(params: any[]): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            Promise.resolve()
                .then(() => {
                    return this.beforeGetData(params);
                })
                .then((returnModel) => {
                    return this.getDatafromAPI(returnModel);
                })
                .then((result): any => {
                    if (!this.prepareAPIErrorMessage(result)) {
                        return this.afterGetData(result);
                    } else {
                        return result;
                    }
                })
                .then((finalresult) => {
                    resolve(finalresult);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    beforePostData(model: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            resolve(this.transFormModel(model));
        });
    }

    beforeGetData(model: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            resolve(this.transFormModel(model));
        });
    }

    afterPostData(model: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            resolve(this.transformAPIData(model));
        });
    }

    afterGetData(model: T): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            resolve(this.transformAPIData(model));
        });
    }

    transFormModel(model: any): any {
        return model;
    }

    transformAPIData(data: any) {
        return data;
    }

    getImageData(url: string): any {
        this.httpService
            .getImage(url)
            .then((data) => {
                return data;
            })
            .catch((err) => {
                return err;
            });
    }

    getDataByUrl(url: string): Promise<any> {
        return new Promise<T>((resolve, reject) => {
            this.httpService
                .getData(url)
                .then((data) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
}
